import {
  Maybe,
  User,
  UserLevel,
  UserProgramModel,
} from 'src/graphql/generated/graphql';

export const getFullName = (
  user: Partial<User> | Maybe<User> | undefined,
  separator = ' ',
) => {
  if (!user) {
    return '';
  }

  const fullName = [user?.firstName, user?.lastName]
    .filter((item) => !!item)
    .join(separator);

  return fullName;
};

export const getIsOtpPro = (user: Partial<User> | Maybe<User> | undefined) => {
  const userLevels = getUserLevels(user);
  return userLevels?.some((level) => level === UserLevel.Otp3);
};

export const getIsOtpProAndHigher = (
  user: Partial<User> | Maybe<User> | undefined,
) => {
  const userLevels = getUserLevels(user);
  return userLevels?.some((level) =>
    [UserLevel.Otp3, UserLevel.Otp4].includes(level),
  );
};

export const getUserLevels = (
  user: Partial<User> | Maybe<User> | undefined,
): UserLevel[] => {
  return getUserPrograms(user).map(
    (program) => (program as UserProgramModel & { level: UserLevel }).level,
  );
};

export const getUserPrograms = (
  user: Partial<User> | Maybe<User> | undefined,
) => {
  if (!user) {
    return [];
  }

  return user.programs || [];
};
